import "./Input.css";
import React, { Fragment } from "react";
import { TextField } from "@mui/material";
// import { makeStyles } from "@mui/styles";

const Input = ({
  inputProps = "",
  selectedType,
  label,
  errors,
  name,
  register = "",
  defaultValue = "",
  disabled = false,
  value = "",
  className="bg-white w-100 my-2 mui-text-field",
  watch = () => null,

  onChange,
}) => {
  return (
    <Fragment>
      <TextField
        error={typeof errors === "boolean" ? errors : errors && errors[name]}
        helperText={errors && errors[name]?.message}
        type={selectedType}
        size="small"
        variant="outlined"
        className={className}
        inputProps={inputProps}
        label={label}
        // InputLabelProps={{ style: { color: "rgba(100,100,100,.4)" } }}
        value={watch(name) < 0 ? "" : watch(name) || value}
        defaultValue={defaultValue}
        disabled={disabled}
        onChange={onChange}
        {...register}
      />
    </Fragment>
  );
};

export default Input;
